import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalConsultComponent } from '../../modal-consult/modal-consult.component';
import { ActivityManagementService } from '../../../activity-management.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-add-consult',
  templateUrl: './add-consult.component.html',
  styleUrls: ['./add-consult.component.scss']
})
export class AddConsultComponent implements OnInit {
  date: Date;
  uid: string;
  times = [];
  status = [];
  consultDetails;
  model = [];
  selected = [];

  constructor(
    public matDialog: MatDialog,
    private router: Router,
    private activityManagementService: ActivityManagementService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    // console.log(window.history.state);
    // console.log(window.history.state['consult-uid']);
    this.gobalFunctionService.setTitle('เพิ่ม Consult');

    if (!window.history.state['consult-uid']) {
      this.router.navigate(['activity-management/consult']);
    } else {
      this.uid = window.history.state['consult-uid'];
      this.date = new Date(+window.history.state['consult-date']);
      this.getConsultDetail();
    }
  }

  getConsultDetail() {
    let dateToServer = this.date.toISOString().slice(0, 10);

    this.activityManagementService.getDetailConsultByDate({ USER_ID: this.uid, CONSULT_DATE: dateToServer }).subscribe(res => {
      this.consultDetails = res.result;
      // console.log(this.consultDetails);

      for (let i = 0; i < res.result.length; i++) {
        this.times[i] = new Date(this.consultDetails[i].CONSULT_DATE);
        if (this.consultDetails[i].CONSULT_STATUS === 'joined' || this.consultDetails[i].CONSULT_STATUS === 'busy') {
          this.status[i] = true;
        } else {
          this.status[i] = false;
        }
      }
    })
  }

  add(e, c, i) {
    e.preventDefault();
    // // console.log(this.consultDetails[i]);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '450px';
    dialogConfig.autoFocus = false;

    if (c.CONSULT_STATUS === 'empty' || c.CONSULT_STATUS === 'delete') {
      dialogConfig.data = {
        title: 'สร้างช่วงเวลา',
        actionBtnText: 'เพิ่ม',
        value: c,
        uid: this.uid,
        isEdit: false
      }
    }
    // // console.log(c);

    const modal = this.matDialog.open(ModalConsultComponent, dialogConfig);
    modal.afterClosed().subscribe(res => {
      if (res.status) {
        c.CONSULT_DETAIL.push(res.obj);
        this.status[i] = !this.status[i];
        this.selected[i] = res.obj;
        c.CONSULT_STATUS = 'busy';
        // // console.log(this.selected);
      }
    })
  }

  edit(e, c, i) {
    e.preventDefault();

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '450px';
    dialogConfig.autoFocus = false;
    if (c.CONSULT_STATUS === 'busy' || c.CONSULT_STATUS === 'edit') {
      dialogConfig.data = {
        title: 'แก้ไขช่วงเวลา',
        actionBtnText: 'บันทึก',
        value: c.CONSULT_DETAIL[0],
        uid: this.uid,
        isEdit: true
      }
    }

    const modal = this.matDialog.open(ModalConsultComponent, dialogConfig);
    modal.afterClosed().subscribe(res => {
      if (res.status) {
        this.selected[i] = res.obj;
        c.CONSULT_STATUS = 'edit';
      }
      if (res.isDelete) {
        this.status[i] = false;
        this.selected[i] = res.obj;
        c.CONSULT_STATUS = 'delete';
      }
    })
  }

  create() {
    this.selected = this.selected.filter(v => v);
    // console.log(this.selected);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '350px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'ยืนยันการบันทึก',
      description: `คุณต้องการบันทึก Consult ใช่หรือไม่?`,
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ยกเลิก',
    }

    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    // // console.log(res);
    modal.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.activityManagementService.createConsult(this.selected).pipe(
            switchMap(() => {
              const dialogConfig2 = new MatDialogConfig();
              dialogConfig2.disableClose = true;
              dialogConfig2.id = 'modalSuccess';
              dialogConfig2.width = '350px';
              dialogConfig2.data = {
                title: 'สำเร็จแล้ว',
                description: `<img src="../../../assets/check.png" width="100px;" class="img-center">บันทึก Consult สำเร็จแล้ว`,
                cancleBtnText: 'ยืนยัน',
                customStyle: 'background-color: #58595B;'
              }
              const modal2 = this.matDialog.open(ModalComponent, dialogConfig2);
              return modal2.afterClosed().pipe(
                map(res => {
                  // console.log(res);

                  this.selected = [];
                  this.getConsultDetail();
                  this.router.navigate(['activity-management/consult']);
                })
              )
            })
          )
        } else {
          return of(null);
        }
      })
    ).subscribe()
  }

  getHourse(t) {
    return t.getHours() + ':00';
  }

  moreThanOne(selected) {
    if (selected.length > 0) {
      return true;
    } else {
      return false
    }
  }
}
